





















































































































































































































































































































































































































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";

import EstimateItem from "../components/EstimateItem.vue";
import EstimateHeader from "../components/EstimateHeader.vue";

import Estimate from "@/usecases/orders/estimate";
import EstimateItemModel from "@/usecases/orders/estimate-item";
import VToolbar from "../../common/components/VToolbar.vue";
import EstimateService from "@/usecases/orders/estimate-service";
import MoveEvent from "../presenters/move-event";
import SelectOption from "@/common/ui/presenters/select-option";
import { getAllProjects } from "@/api/project-api";
import EstimateApi from "../../../api/orders/estimate-api";
import { client } from "@/api/request";
import EstimateStatus from "@/usecases/orders/estimate-status";
import EstimateStatusTranslater from "@/usecases/orders/estimate-status-translater";
import UnitApi from "../../../orders/api/unit-api";
import UnitOption from "../presenters/unit-option";
import PrintApi from "../../../api/orders/print-api";
import SwitchButton from "@/components/SwitchButton.vue";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import { estimateRoundedFromProfitRate } from "@/models/estimate-from-profit-rate";
import {
  EstimateTemplate,
  EstimateTemplateItem
} from "@/api/estimate-templates-api";
import UseEstimateTemplate from "@/components/UseEstimateTemplate.vue";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import ProfitRateModal from "@/components/ProfitRateModal.vue";
import ExpensesCategoryGraphReport from "@/ui/order/components/ExpensesCategoryGraphReport.vue";
import { ESTIMATE_ITEM_LEVEL, NUMBER_ROUND, TYPE_ROUND } from "@/preferences";
import EstimateTaskDefaultsForm from "@/ui/order/components/EstimateTaskDefaultsForm.vue";
import {
  getServiceTaskDefaults,
  ServiceTaskDefault
} from "@/api/project/service-task-default-api";
import { ProjectTaskDefault } from "@/api/project-api";
import moment from "moment";
import EstimateTemplateModal from "@/ui/order/components/EstimateTemplateModal.vue";
import uuid from "uuid";
import Decimal from "decimal.js";

const printApi = new PrintApi(client);
const estimateApi = new EstimateApi(client);
const unitApi = new UnitApi(client);
const service = new EstimateService(estimateApi);

@Component({
  methods: {
    TYPE_ROUND() {
      return TYPE_ROUND;
    },
    NUMBER_ROUND() {
      return NUMBER_ROUND;
    }
  },
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    EstimateTemplateModal,
    ExpensesCategoryGraphReport,
    ProfitRateModal,
    TextTemplateModal,
    UseEstimateTemplate,
    VToolbar,
    EstimateItem,
    EstimateHeader,
    SwitchButton,
    EstimateTaskDefaultsForm
  }
})
export default class EditEstimatePage extends Vue {
  @Prop({ required: true }) id!: string;
  @Prop({ required: true }) projectId!: number;

  textTemplateModalOpen = false;
  calcFromProfitRateModalOpen = false;
  calcInvoiceFromProfitRateModalOpen = false;

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    const grandchildren = e.draggedContext.element.items.reduce(
      (total, item) => total + item.items.length,
      0
    );
    return !(
      (from === "parents" && to === "grandchildren" && children > 0) ||
      (from === "children" && to === "grandchildren" && children > 0) ||
      (from === "parents" && to === "children" && grandchildren > 0)
    );
  }

  estimate = new Estimate();
  projectOptions: SelectOption[] = [];
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];
  isShowNoteColumn: boolean = true;
  expenseCategoriesSelected: any[] = [];
  headerDefault: HeaderItem[] = [
    {
      name: "見積項目",
      subs: [
        { name: "大項目", width: "9rem" },
        { name: "中項目", width: "9rem" },
        { name: "小項目", width: "9rem" },
        { name: "経費カテゴリ", width: "7rem" },
        { name: "数量", width: "3rem" },
        { name: "単位", width: "5rem" },
        { name: "単価", width: "6rem" },
        { name: "見積金額", width: "6rem" },
        { name: "備考", width: "1fr" }
      ]
    },
    {
      name: "予算項目",
      subs: [
        { name: "発注単価", width: "6rem" },
        { name: "発注金額", width: "6rem" },
        { name: "利益額", width: "6rem" },
        { name: "利益率", width: "5rem" },
        { name: "発注先", width: "7rem" }
      ]
    },
    {
      name: "操作",
      subs: [],
      width: "4rem"
    }
  ];
  headerWithoutNoteColumn: HeaderItem[] = [
    {
      name: "見積項目",
      subs: [
        { name: "大項目", width: "9rem" },
        { name: "中項目", width: "9rem" },
        { name: "小項目", width: "9rem" },
        { name: "経費カテゴリ", width: "7rem" },
        { name: "数量", width: "3rem" },
        { name: "単位", width: "5rem" },
        { name: "単価", width: "1fr" },
        { name: "見積金額", width: "1fr" }
      ]
    },
    {
      name: "予算項目",
      subs: [
        { name: "発注単価", width: "1fr" },
        { name: "発注金額", width: "1fr" },
        { name: "利益額", width: "1fr" },
        { name: "利益率", width: "1fr" },
        { name: "発注先", width: "7rem" }
      ]
    },
    {
      name: "操作",
      subs: [],
      width: "4rem"
    }
  ];
  header: HeaderItem[] = this.headerDefault;
  styleGridColumn: string = this.getWidthsString(this.header);
  // The Set includes the IDs of the estimate_row at the lowest level.
  // Saving like this is for the logic of reloading the checkbox state when dragging and dropping in the table
  estimateRowSelected: Set<string> = new Set();
  isCheckAllEstimateRow: boolean = false;
  disableDestroy: boolean = true;
  orderToEstimatedNumberRound: number = NUMBER_ROUND[1];
  orderToEstimatedTypeRound: string = TYPE_ROUND[0];
  estimatedToOrderNumberRound: number = NUMBER_ROUND[1];
  estimatedToOrderTypeRound: string = TYPE_ROUND[0];
  displayDateOfContract: boolean = false;

  toggleNoteColumn(isChecked: boolean) {
    this.isShowNoteColumn = isChecked;
    this.header = isChecked ? this.headerDefault : this.headerWithoutNoteColumn;
    this.styleGridColumn = this.getWidthsString(this.header);
  }

  getWidthsString(header: HeaderItem[]): string {
    const widths: string[] = [];

    header.forEach(item => {
      if (item.subs.length === 0 && item.width) {
        widths.push(item.width);
      } else {
        item.subs.forEach(sub => {
          widths.push(sub.width);
        });
      }
    });

    return widths.join(" ");
  }

  addIdsFromLowestItems(items: EstimateItemModel[]) {
    items.forEach(item => {
      if (item.items.length > 0) {
        this.addIdsFromLowestItems(item.items);
      } else {
        this.estimateRowSelected.add(item.id.toString());
      }
    });
  }

  checkAllEstimateRow(isChecked: boolean) {
    this.estimateRowSelected.clear();

    if (isChecked) {
      this.addIdsFromLowestItems(this.estimate.items);
      this.addIdsFromLowestItems(
        this.estimate.children.flatMap(child => child.items)
      );
    }

    this.reloadCheckboxOfEstimateRow();
  }

  getHeaderOfSubTable(title: string) {
    let result: HeaderItem[] = [{ name: title, subs: [] }];
    return result;
  }

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  printing: boolean = false;

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      try {
        const url = await printApi.getEstimatePrint(
          id,
          this.$store.state.accessToken,
          printsExcludeTax
        );
        window.open(url, "見積書印刷");
      } catch (e) {
        alert("印刷に失敗しました。しばらく待ってから改めてお試しください。");
      } finally {
        this.printing = false;
      }
    } else {
      alert("印刷中です");
    }
  }

  get statusOptions() {
    return EstimateStatus.all().map(value => ({
      value,
      text: EstimateStatusTranslater.toJp(value)
    }));
  }

  goListPage() {
    this.$router.push({ name: "order-estimates" });
  }

  containsHyphen(set: Set<string>): boolean {
    const array = Array.from(set);
    for (const value of array) {
      if (value.includes("-")) {
        return true;
      }
    }
    return false;
  }

  hasNewEstimateRow(): boolean {
    const idsSelected = service.getIdsSelected(
      this.estimate,
      this.estimateRowSelected
    );
    return this.containsHyphen(idsSelected);
  }

  goNewPurchasePage() {
    // Check if there are new estimate rows in id selected list
    if (this.hasNewEstimateRow()) {
      alert(
        "見積書内容を再度更新する必要があります。\n" +
          "保存ボタンを押した後に発注書作成を行ってください。"
      );
      return;
    }

    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }

    const ids = service.getIdsSelected(this.estimate, this.estimateRowSelected);

    this.$router.push({
      name: "order-estimate-purchase",
      params: {
        estimateId: String(this.estimate.id),
        idsRowSelected: Array.from(ids).join(",")
      }
    });
  }

  status = "";

  async save() {
    try {
      this.status = "progressing";
      await service.save(this.estimate);
      await this.edit(Number(this.id));
      // After updating the estimate, the id of the estimate_row is newly generated
      // and needs to be mapped with the ids being checked on the screen.
      this.mappingNewEstimateRowId();
      await this.$store.dispatch("getStatusProject");
      alert("保存しました。");
    } catch (e) {
      alert("保存に失敗しました。");
    } finally {
      this.status = "";
    }
  }

  async addNewItems(items: number) {
    for (let i = 0; i < items; i++) {
      await service.addNewItem(this.estimate);
    }
    this.reloadCheckboxOfEstimateRow();
  }

  async addNewItemAfter(itemId: string) {
    await service.addNewItemAfter(this.estimate, itemId);
    this.reloadCheckboxOfEstimateRow();
  }

  async removeItem(itemId: string) {
    this.estimate = await service.removeItem(this.estimate, itemId);
    this.estimateRowSelected.delete(itemId);
    this.reloadCheckboxOfEstimateRow();
  }

  async removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.estimate = await service.removeAllItems(this.estimate);
    this.estimateRowSelected.clear();
    this.reloadCheckboxOfEstimateRow();
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(Number(this.id));
    this.goListPage();
    this.$store.dispatch("getStatusProject");
  }

  async createCsv() {
    const url = await service.csvDownload(Number(this.id));
    window.open(url);
  }

  async calculateTotal() {
    this.estimate = await service.calculateTotal(this.estimate);
    this.loadExpenseCategory();
  }

  async calculateInvoice(profitRate: number) {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }
    if (!confirm("発注額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }
    this.estimate = await service.calculateInvoice(
      this.estimate,
      profitRate,
      service.getIdsSelected(this.estimate, this.estimateRowSelected),
      this.estimatedToOrderNumberRound,
      this.estimatedToOrderTypeRound
    );
  }

  private editing = false;

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculateTotal();
    this.reloadCheckboxOfEstimateRow();
  }

  protected async created() {
    await this.edit(Number(this.id));
    await this.initProjectList();
    await this.initUnitList();
    await this.initExpenseCategories();
    await this.loadExpenseCategory();
    await this.getServiceTaskDefaults();
  }

  private async edit(id: number) {
    this.estimate = await service.find(id);
    if (!this.estimate.projectId) {
      this.estimate.projectId = this.projectId;
    }
    this.disableDestroy = this.isDisableDestroy();
    this.displayDateOfContract = this.isDisplayDateOfContract();
  }

  private async initProjectList() {
    this.projectOptions = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  async initExpenseCategories() {
    this.expenseCategories = [
      { id: "", name: "", important: false },
      ...(await getExpenseCategories())
    ];
  }

  async calculateFromProfitRate(profitRate: number) {
    if (this.estimateRowSelected.size === 0) {
      alert("対象品目をチェックしてください。");
      return;
    }
    if (!confirm("見積額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }

    // TODO: asしなくても通るように型定義したい
    this.estimate = estimateRoundedFromProfitRate(
      this.estimate,
      profitRate,
      service.getIdsSelected(this.estimate, this.estimateRowSelected),
      this.orderToEstimatedNumberRound,
      this.orderToEstimatedTypeRound
    ) as Estimate;
    this.estimate = await service.calculateTotal(this.estimate);
  }

  /**
   * 既存の項目からテンプレートを作る
   */
  saveTemplate(templateName: string) {
    let items: EstimateItemModel[] = [];
    items.push(...this.estimate.items);
    this.estimate.children.forEach(child => items.push(...child.items));
    this.$store.dispatch("estimateTemplate/save", {
      title: templateName,
      items: items,
      orderNew: 1
    });
  }

  /**
   * テンプレートを使う
   */
  useTemplate(template: EstimateTemplate): void {
    const items = template.items.map(templateItemToItem);
    items.forEach(item => {
      this.estimate.items.push(item);
    });
    this.calculateTotal();
  }

  addTextToMention(text: string) {
    if (this.estimate.mention) {
      this.estimate.mention += "\n";
    }
    this.estimate.mention += text;
    this.textTemplateModalOpen = false;
  }

  get expenseCategoriesLabel() {
    return this.expenseCategoriesSelected.map(item =>
      String(item.expenseCategoryName)
    );
  }

  get expenseCategoriesValue() {
    return this.expenseCategoriesSelected.map(item => Number(item.total));
  }

  calculateExpenseCategory(
    items: EstimateItemModel[],
    options: any[],
    result: any[]
  ) {
    for (let i = 0; i < items.length; i++) {
      if (items[i].expenseCategoryId !== "" && items[i].loss !== 0) {
        const name = options
          .filter(option => option.value === items[i].expenseCategoryId)
          .map(option => option.text);
        const categoryExists = result.find(
          item => item.expenseCategoryId === items[i].expenseCategoryId
        );

        if (!categoryExists) {
          result.push({
            expenseCategoryId: items[i].expenseCategoryId,
            expenseCategoryName: name.length === 0 ? "" : name[0],
            total: items[i].loss
          });
        } else {
          categoryExists.total += items[i].loss;
        }
      }
    }
  }

  processExpenseCategory(
    items: EstimateItemModel[],
    options: any[],
    result: any[]
  ) {
    this.calculateExpenseCategory(items, options, result);
    items.forEach(item => {
      if (item.items && item.items.length > 0) {
        this.processExpenseCategory(item.items, options, result);
      }
    });
  }

  loadExpenseCategory() {
    let categories: any[] = [];
    let categoryOptions = this.expenseCategoryOptions;

    // Process estimate items
    this.processExpenseCategory(
      this.estimate.items,
      categoryOptions,
      categories
    );

    // Process estimate children
    this.estimate.children.forEach(child => {
      this.processExpenseCategory(child.items, categoryOptions, categories);
    });

    this.expenseCategoriesSelected = categories;
  }

  deleteRowIdInvalid(item: EstimateItemModel) {
    if (item.items.length > 0) {
      if (this.estimateRowSelected.has(item.id.toString())) {
        this.estimateRowSelected.delete(item.id.toString());
      }
      item.items.forEach(it => this.deleteRowIdInvalid(it));
    }
  }

  deleteIdInvalidInEstimateRowSelected() {
    this.estimate.items.forEach(item => this.deleteRowIdInvalid(item));
    this.estimate.children.forEach(child =>
      child.items.forEach(item => this.deleteRowIdInvalid(item))
    );
  }

  reloadCheckboxOfEstimateRow() {
    // delete the parent row id if there is a child row id in the set
    this.deleteIdInvalidInEstimateRowSelected();

    // Recreate the set to trigger reactivity
    this.estimateRowSelected = new Set(Array.from(this.estimateRowSelected));

    // reload checkbox all row
    this.reloadCheckboxAll();
  }

  convertToNewEstimateRowId(items: EstimateItemModel[]) {
    items.forEach(item => {
      if (this.estimateRowSelected.has(item.rowUuid.toString())) {
        this.estimateRowSelected.delete(item.rowUuid.toString());
        this.estimateRowSelected.add(item.id.toString());
      }
      if (item.items.length > 0) {
        item.items.forEach(itemChild => {
          if (this.estimateRowSelected.has(itemChild.rowUuid.toString())) {
            this.estimateRowSelected.delete(itemChild.rowUuid.toString());
            this.estimateRowSelected.add(itemChild.id.toString());
          }
        });
      }
    });
  }

  mappingNewEstimateRowId() {
    if (this.estimateRowSelected.size > 0) {
      this.convertToNewEstimateRowId(this.estimate.items);
      this.estimate.children.forEach(child =>
        this.convertToNewEstimateRowId(child.items)
      );
      this.reloadCheckboxOfEstimateRow();
    }
  }

  projectTaskDefaultDate = "";
  private async getServiceTaskDefaults() {
    const serviceTaskDefaults = await getServiceTaskDefaults();
    serviceTaskDefaults.forEach((item: ServiceTaskDefault) => {
      if (
        item.code == "Estimate task default" &&
        !this.estimate.taskDefaults.length
      ) {
        this.estimate.taskDefaults.push({
          key: {
            id: item.id,
            name: item.name
          },
          value: item.value
        } as ProjectTaskDefault);
      }
    });

    const projectTaskDefault = this.$store.state.project.taskDefaults.find(
      (item: ProjectTaskDefault) => item.key.code == "Project task default"
    );
    if (projectTaskDefault) {
      this.projectTaskDefaultDate =
        projectTaskDefault.value ||
        moment()
          .add(projectTaskDefault.key.value, "days")
          .format("YYYY-MM-DD");
    } else {
      this.projectTaskDefaultDate = "";
    }
  }

  reloadCheckboxAll() {
    let numberItems = this.countTotalItems(this.estimate.items);
    this.estimate.children.forEach(child => {
      numberItems += this.countTotalItems(child.items);
    });
    if (numberItems === 0) {
      this.isCheckAllEstimateRow = false;
      return;
    }
    let countItemsSelected = service.getIdsSelected(
      this.estimate,
      this.estimateRowSelected
    ).size;
    this.isCheckAllEstimateRow = countItemsSelected === numberItems;
  }

  countTotalItems(items: EstimateItemModel[]): number {
    let result = 0;
    result += items.length;
    items.forEach(item => {
      if (item.items.length > 0) {
        result += this.countTotalItems(item.items);
      }
    });
    return result;
  }

  isDisableDestroy(): boolean {
    return (
      this.estimate.status === EstimateStatus.QuotedNew ||
      this.estimate.status === EstimateStatus.Success
    );
  }

  changeEstimateStatus() {
    this.displayDateOfContract = this.isDisplayDateOfContract();
  }

  isDisplayDateOfContract(): boolean {
    return this.estimate.status === EstimateStatus.Success;
  }

  get lossTotal(): string {
    let totalPrice: number = 0;
    let loss: number = 0;
    this.estimate.items.forEach(item => {
      totalPrice += item.totalPrice;
      loss += item.loss;
    });

    this.estimate.children.forEach(child => {
      child.items.forEach(item => {
        totalPrice += item.totalPrice;
        loss += item.loss;
      });
    });

    return (totalPrice - loss - this.estimate.discount).toLocaleString();
  }

  get templateProfitRate() {
    return {
      profitRate: new Decimal(this.estimate.profitRate).div(100).toNumber(),
      lossRate: new Decimal(this.estimate.lossRate).div(100).toNumber()
    };
  }
}

function templateItemToItem(item: EstimateTemplateItem): EstimateItemModel {
  return {
    ...item,
    id: uuid(),
    rowUuid: "",
    totalPrice: 0,
    loss: 0,
    items: (item.items || []).map(n => templateItemToItem(n)),
    purchased: false,
    purchasedRow: false,
    vendorName: ""
  };
}
